export const serviceCategoriesData = [
  {
    id: 1,
    title: "Web Design",
    img: "/assets/images/service-images/Service-1.svg",
    serviceUrl: "design",
  },
  {
    id: 2,
    title: "Digital Branding",
    img: "/assets/images/service-images/Service-2.svg",
    serviceUrl: "design",
  },
  {
    id: 3,
    title: "Coding </>",
    img: "/assets/images/service-images/Service-3.svg",
    serviceUrl: "development",
  },
  {
    id: 4,
    title: "Web / Mobile Apps",
    img: "/assets/images/service-images/Service-4.svg",
    serviceUrl: "development",
  },
];
